export default __webpack_public_path__ + "static/media/img_company_header33.c24c41ed.png";